import { render, staticRenderFns } from "./SingleCoupon.vue?vue&type=template&id=3ad89d54&scoped=true&"
import script from "./SingleCoupon.vue?vue&type=script&lang=ts&"
export * from "./SingleCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCoupon.vue?vue&type=style&index=0&id=3ad89d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad89d54",
  null
  
)

export default component.exports